import { ComponentType } from 'react'

import { isTouchCached } from 'utils/device'

export function makeDesktopOrMobileComponent<T extends Record<string, any>>(
  DesktopComponent: ComponentType<T>,
  MobileComponent: NoInfer<ComponentType<T>>,
) {
  if (isTouchCached()) {
    return MobileComponent
  }

  return DesktopComponent
}
